// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3W8P-","delete":"styles_delete__38C5v","update":"styles_update__5VHKQ","add":"styles_add__1V_vj"};